import React from 'react';
import { Chip } from '@naf-simba/elements-chips';
import { Close } from '@naf-simba/building-blocks-icons/General';
import { FilterType } from '@appTypes/urlParamsType';
import { useFilterAction, useFilterCheckedMap } from '@utils/bilguide';
import { ChipWrapper, Wrapper } from './ActiveFilterChips.styles';
import { getChipLabel } from './ActiveFilterChips.utils';

const ActiveFilterChips = () => {
  const { applyFilter, clearAllFilters } = useFilterAction();
  const { filter } = useFilterCheckedMap();

  const activeFilters = Object.entries(filter ?? {}).flatMap(([key, values]) =>
    (values ?? []).map((value) => ({ key: key as keyof FilterType, value })),
  );

  if (activeFilters.length === 0) return null;

  return (
    <Wrapper>
      <Chip
        label="Fjern alle filtre"
        variant="filled"
        color="secondary"
        shade="light"
        size="small"
        onClick={clearAllFilters}
      />
      {activeFilters.map(({ key, value }) => (
        <ChipWrapper key={`${key}-${value}`}>
          <Chip
            label={getChipLabel(key, value)}
            endIcon={Close}
            variant="outlined"
            color="primary"
            size="small"
            aria-label={`Fjern ${getChipLabel(key, value)}`}
            onClick={() => applyFilter(key, value)}
          />
        </ChipWrapper>
      ))}
    </Wrapper>
  );
};

export default ActiveFilterChips;
